<template>
  <footer class="text-light">
    <b-container>
      <b-row cols="1" cols-sm="2">
        <b-col>
          <h6>Endereço</h6>
          <p class="text-white-50">
            Av. Prudente de Morais, nº 577, Tirol - Natal/RN.<br />
            <b>CEP: </b>59.020-505
          </p>
        </b-col>
        <b-col>
          <h6>E-mail</h6>
          <p class="text-white-50">cpgeo@cpgeo.com<br /></p>
          <h6>Telefone</h6>
          <p class="text-white-50">(84) 99121-8551</p>
        </b-col>
      </b-row>
      <div class="border-top mt-3 pt-4 text-white-50 text-center">
        Copyright &copy;2022 CPGeo. Todos os direitos reservados
      </div>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
footer {
  padding-top: 3em;
  padding-bottom: 2em;
  border-style: solid;
  border-width: thick 0px 0px 0px;
  border-color: #f3c105;
  background-color: #333333;
}

.border-top {
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}
</style>
